import { 
    ModalBuilder as DiscordModalBuilder,
    ModalComponentData,
    APIModalInteractionResponseCallbackData
} from "discord.js"

export class ModalBuilder extends DiscordModalBuilder {
    private customId: string;
    private userId?: string;
    private arguments: string[];
    
    constructor(data?: Partial<ModalComponentData> | Partial<APIModalInteractionResponseCallbackData>) {
        super(data);
    }

    override setCustomId(id: string) {
        this.customId = id;

        const customId = [this.customId, this.userId ?? "", ...(this.arguments ?? [])].join("/");

        return super.setCustomId(customId);
    }

    setUserId(id?: string) {
        this.userId = id;

        const customId = [this.customId ?? "", this.userId ?? "", ...(this.arguments ?? [])].join("/");

        return super.setCustomId(customId);
    }

    setArguments(...args: string[]) {
        this.arguments = args;
        args.unshift(this.userId ?? "")
        args.unshift(this.customId ?? "")

        return super.setCustomId(args.join("/"));
    }
}